module.exports = __webpack_public_path__ + "15823d2d1d8b7dd87a761575ba893b96.png";